import { useParams } from "react-router-dom";
import { useSprintQuery } from "sprint-common-web";

import { useCloudFileApi } from "../../../../common/api/master-api/cloud-files/useCloudFileApi";
import { CloudFileDetails, mapToCloudFileDetails } from "../CloudFileDetails";
import { CloudFileQueryKey } from "./CloudFileQueryKey";

export const useCloudFileDetails = () => {
    const { cloudFileId } = useParams<{ cloudFileId: string }>();

    const { getCloudFileDetails } = useCloudFileApi();

    return useSprintQuery<CloudFileDetails>({
        queryKey: [CloudFileQueryKey.CloudFileDetails, cloudFileId],
        queryFn: async (): Promise<CloudFileDetails> => {
            const response = await getCloudFileDetails({ cloudFileId });

            return mapToCloudFileDetails(response);
        }
    });
};
